export enum COMMON_KEYS {
  LOCALE = 'locale',
  BRAND_URLS_KEY = 'serverBrandUrls',
  CANDIDATE_VEHICLES_KEY = 'candidateVehicles',
  CART = 'ocShopCart',
  CART_PREVIOUSLY_VISITED = 'cartPreviouslyVisited',
  CHECK_SESSION_TIMEOUT_INTERVAL = 32, // (32 minutes)
  COMPATIBLE_DEVICES_KE = 'compatibleDevicesKey',
  CGI_YEAR_OFFSET = 0,
  CHECKED_ON_STAR_TCPS_KEY = 'checkedOnStarTcpsKey',
  CHROME_MMY_VALUES_KEY = 'chromeMmyValues',
  CMS_CACHE_KEY = 'cmsCacheKey',
  CURRENT_BRAND = 'currentBrand',
  DEVICE_CARRIERS_KEY = 'deviceCarriersKey',
  DEVICES_KEY = 'devicesKey',
  DEVICE_MANUFACTURERS_KEY = 'deviceManufacturersKey',
  DIAGNOSTIC_DATA_KEY = 'diagnosticDataKey',
  ENROLLED_OVDEMAIL_DIAGNOSTIC_REPORTS_KEY = 'enrolledOVDEmailDiagnosticReports',
  FM_INVITE = 'fm_invite',
  FM_INVITE_TAB = 'fm_invite_tab',
  GARAGE_KEY = 'Garage',
  GARAGE_VEHICLES_SVC_INFO_RETRIEVED = 'garageVehiclesSvcInfoRetrieved',
  GLOBAL_CUSTOMER_KEY = 'globalCustomer',
  IMPERSONATED_USER_LIST_KEY = 'impersonatedUserList',
  LANGUAGE = 'language',
  LEGAL_ACCEPTANCE_URL = 'legalAcceptanceUrl',
  LIFE_TIME_STATISTICS_KEY = 'lifeTimeStatisticsKey',
  LOGIN_SUCCESS_KEY = 'loginSuccess',
  LOGIN_METHOD_KEY = 'loginMethodKey',
  MAINTENANCE_TOOLS_KEY = 'maintenanceToolsKey',
  MARKETING_CONTENT_TRACKING = 'marketingContentTracking',
  MONTH_TIME_FRAME_STATISTICS_KEY = 'monthTimeFrameStatisticsKey',
  NEWLY_ADDED_VEHICLES_KEY = 'newlyAddedVehicles',
  NOO_QUALIFIED_VEHICLES_KEY = 'nooQualifiedVehicles',
  NOO_MODULE_ORDER_KEY = 'nooModuleOrder',
  NOO_REENTRY_KEY = 'nooReentry',
  NOO_SETTINGS_KEY = 'nooSettingsKey',
  NOO_URL_KEY = '/getstarted',
  NOO_VEHICLES_KEY = 'nooVehicles',
  NOO_VERIFICATION_KEY = 'ucVer',
  NOTIFICATIONS_KEY = 'notifications',
  ON_STAR_ACCOUNT_KEY = 'onStarAccountKey',
  ON_STAR_LEGAL_KEY = 'OnStarLegal',
  OVD_KEY = 'ovd',
  OWNER_PROFILE_KEY = 'ownerProfile',
  LOGIN_TYPE_KEY = 'loginType',
  PIN_SETUP_KEY = '/pinsetup',
  PROACTIVE_DATA_KEY = 'proactiveDataKey',
  RECALL_KEY = 'recalls',
  RPO_CODES_AND_RADIO_TYPESKey = 'rpoCodesAndRadioTypes',
  SALES_INFO_ID_KEY = 'salesInfoId',
  SEARCH_YEAR_MODEL_KEY = 'searchYearModel',
  SECURITY_QUESTIONS_KEY = 'securityQuestions',
  SESSION_TIMEOUT_WARNING_INTERVAL = 25, // (minutes)
  SUBSCRIBER_DATA_KEY = 'subscriberDataKey',
  UN_AUTHENTICATED_VIN = 'unAuthenticatedVin',
  WARRANTIES_KEY = 'warranties',
  WEEK_TIME_FRAME_STATISTICS_KEY = 'weekTimeFrameStatisticsKey',
  YEAR_TIME_FRAME_STATISTICS_KEY = 'yearTimeFrameStatisticsKey',
  ACCT_MATCHING_COMPLETED = 'acctMatchingCompleted',
  LOCATE_DEALER_BY_ZIP = 'locateDealerByZip',
  LOCATE_DEALER_BY_CITY_STATE = 'locateDealerByCityState',
  LOCATE_DEALER_BY_CITY = 'locateDealerByCity',
  LOCATE_DEALER_BY_NAME = 'locateDealerByName',
  LOCATE_DEALER_BY_LATLONG = 'locateDealerLatLong',
  RECALLS_GFAS_KEY = 'recallsGfas',
  INIT_LOGIN_SUCCESS_DATA = 'initData',
  DECRYPT_VIN = 'recallCampaignVin',
  TAKATA_SIGN_UP = 'saveTakataRecallData',
  TAKATA_SMS_SIGN_UP = 'signupForSMS',
  PDP_ERROR_STATE = 'pdpMfeErrorState',
  COPYDATA = 'COPYDATA',
  ONSTAR_CHECKOUT = 'onstarPciCheckout',
  PAYMENT_RETURN_URL_KEY = 'paymentReturnUrl',
  PAYMENT_IS_TEMP_KEY = 'paymentIsTemp',
  GET_REVIEW_INFO = 'getReviewPlanInfo',
  REVIEW_INFO = 'reviewInfo',
  THEME_ID = 'themeID',
  LAUNCH_DARKLY = 'launchDarkly',
  CHECKOUT_QUOTE = 'checkoutQuote',
  RECURRING_CHARGES = 'recurringCharges',
  CANCEL_PLANS = 'cancelPlans',
  REBUTTAL_DATA = 'rebuttal_info',
  ORIGINAL_FLAGS = 'originalFlags',
  AUTH_RECOMMENDED_PRODUCTS = 'authRecommendedProducts',
  UNAUTH_RECOMMENDED_PRODUCTS = 'unauthRecommendedProducts',
  YMAL_ASSETS = 'ymalAssets',
  AUTH_COMPARE_PLAN = 'authComparePlan',
  UNAUTH_COMPARE_PLAN = 'unauthComparePlan',
  UNAUTH_PRICING = 'unAuthPricing',
  AUTH_PRICING = 'authPricing',
  UNAUTH_OFFERS = 'unAuthOffers',
  AUTH_OFFERS = 'authOffers',
  ORDER_API = 'orderApiEndPoint',
  STATUS_API = 'statusApiEndPoint',
  PAYMENT_IS_DEFAULT = 'isDefault'
}
